import { type PropsWithChildren, useEffect } from "react"

import { AppContent } from "@/components/app-content"
import { AppMobileHeader } from "@/components/app-mobile-header"
import { AppShell } from "@/components/app-shell"
import { AppSidebar } from "@/components/app-sidebar"

export default function AppSidebarLayout({ children }: PropsWithChildren) {
  // IMP-518: the client app renders in the Compass type (InterVariable).
  // On <html> so portalled surfaces — sheets, popovers, dialogs — inherit it;
  // admin and partner layouts never add the class.
  useEffect(() => {
    document.documentElement.classList.add("compass-type")
    return () => document.documentElement.classList.remove("compass-type")
  }, [])

  return (
    <AppShell variant="sidebar">
      <AppSidebar />
      {/* --app-header-h is what the mobile bar takes off the viewport; it's 0
          on desktop, where the bar is hidden. Full-height panes inside the
          shell subtract it via .h-app-viewport. */}
      <AppContent
        variant="sidebar"
        className="[--app-header-h:3.5rem] md:[--app-header-h:0px]"
      >
        <AppMobileHeader />
        {children}
      </AppContent>
    </AppShell>
  )
}
